<template>
  <v-btn v-bind="$attrs" depressed class="primary" @click="onClick()" tile>
    <v-progress-circular
      v-if="isLoading"
      size="20"
      width="3"
      indeterminate
      color="white"
    ></v-progress-circular>
    <span v-else>
      <slot></slot>
    </span>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (this.isLoading) return;
      this.$emit("click");
    },
  },
};
</script>

<style></style>
